export default __webpack_public_path__ + "media/src/assets/images/locationImageIcon-28be807a6e2b894671499f6fe7e0a058.svg";